import { errorMsg } from "../../../../../Apis/functions";
import { ConnectWithHid, ResetHid, SendInformationSetting } from "../../../../../reduxToolkit/HID/HidApi";
import {toast} from "react-toastify";
import {t} from "i18next";

export const MIN_MAX_CONTROLLER = {
    OFFSET: { start: 100 }
}

export const STATUS_CONTROLLER = {
    ACTIVE: {
        id: 1,
        name: 'active'
    },
    VACATIONS: {
        id: 2,
        name: 'vacations'
    },
    LOCKED: {
        id: 3,
        name: 'locked'
    },
    INACTIVE: {
        id: 4,
        name: 'inactive'
    }
}


export const CONTROLLER_DATA = {
    id: null,
    channelId: null,
    ipAddress: null,
    statusId: null,
    scpId: null,
    name: "",
    description: "",
    formats: [],
    sios: [],
    offset: null,
    toAddEdit: function () {
        return {
            id: this.id,
            channelId: parseInt(this.channelId),
            hidName: this.name,
            ipAddress: this.ipAddress,
            statusId: parseInt(this.statusId),
            scpId: parseInt(this.scpId),
            name: this.name,
            description: this.description || null,
            offset:  parseInt(this.offset),
        }
    },
    isValid: function () {
        return this.channelId != null && this.name != null && this.name !== '' && this.ipAddress != null && this.statusId != null
            && this.scpId != null &&  this.offset !== null;
    },
    set: function (data) {
       return {
           ...this,
           id: data.id,
           channelId: data?.channelId,
           ipAddress: data?.ipAddress,
           statusId: data?.statusId,
           scpId: data?.scpId,
           name: data?.name,
           description: data?.description || null,
           offset: data?.offset,
       }
    }
}

    /**
     * Connect controller to HID
     * Shows success or error toast based on API response
     */
   export  const handleConnect = (dispatch, id) => {
       
        dispatch(ConnectWithHid({ id })).then(
            ({ payload: { data: { data, code, success } } }) => {
                if (success) {
                    toast.success(t('has_been_connected_successfully'));
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    /**
     * Send configuration to controller
     */
   export const handleSetConfig = (dispatch, id) => {
        dispatch(SendInformationSetting({ id })).then(
            ({ payload: { data: { data, code, success } } }) => {
               if (success) {
                toast.success(t('has_been_configured_successfully'));
            } else {
                errorMsg(code);
            }
            }
        );
    };

    /**
     * Reset the controller
     */
    export const handleReset = (dispatch, id) => {
        dispatch(ResetHid({ id })).then(
            ({ payload: { data: { data, code, success } } }) => {
                if (success) {
                toast.success(t('has_been_reset_successfully'));
            } else {
                errorMsg(code);
            }
            }
        );
    };
